/**
 * Shared Product · GI Presenze — Web Push (namespace di prodotto)
 *
 * Wrapper Product-specific attorno al client Foundation
 * (`createWebPushClient`). Il CORE gestisce Web Push API, VAPID, Service Worker.
 * Questo wrapper inietta:
 * - namespace localStorage `presenze_web_push_enabled`
 * - path Service Worker `/service-worker.js` (asset del Product Pack)
 *
 * Ogni Product Pack diverso (GI Clienti, GI Studio, ...) creera' un proprio
 * wrapper analogo, senza toccare il Foundation.
 */
import { createWebPushClient, isWebPushSupported } from "@/foundation/notifications";

const LS_KEY = "presenze_web_push_enabled";
const SW_PATH = "/service-worker.js";

const _client = createWebPushClient({ storageKey: LS_KEY, swPath: SW_PATH });

// Re-export utility CORE + API del client parametrizzato con la stessa
// superficie pubblica pre-P2.0 (retrocompatibilita' consumer legacy).
export { isWebPushSupported };

export function getWebPushLocalEnabled() {
  return _client.getLocalEnabled();
}

export function getServerPublicKey() {
  return _client.getServerPublicKey();
}

export function enableWebPush(categories) {
  return _client.enable(categories);
}

export function disableWebPush() {
  return _client.disable();
}

export function getWebPushStatus() {
  return _client.getStatus();
}

export function updateWebPushCategories(categories) {
  return _client.updateCategories(categories);
}
